import { JSONContent } from '@tiptap/react';
import {
  RichTextEditor,
  Stack,
  Text,
  useRichTextEditor,
} from '@zorro/web/design-system';
import _debounce from 'lodash/debounce';
import { Controller, UseFormReturn } from 'react-hook-form';

import { ZorroSetupFormFields } from '../ZorroSetupForm';

type EnrollmentInstructionsEditorProps = {
  zorroSetupForm: UseFormReturn<ZorroSetupFormFields>;
  defaultContentValue: JSONContent | null;
};

const EnrollmentInstructionsEditor = ({
  defaultContentValue,
  zorroSetupForm,
}: EnrollmentInstructionsEditorProps) => {
  const { setValue, control } = zorroSetupForm;

  const { editor } = useRichTextEditor(
    {
      content: defaultContentValue,
      onUpdate({ editor }) {
        const content = editor.isEmpty ? {} : editor.getJSON();
        setValue('enrollmentInstructions', JSON.stringify(content));
      },
    },
    [setValue, defaultContentValue]
  );

  const handleMouseLeave = () => {
    const content = editor && !editor.isEmpty ? editor.getJSON() : {};

    setValue('enrollmentInstructions', JSON.stringify(content), {
      shouldDirty: true,
    });
  };

  return (
    <Controller
      name="enrollmentInstructions"
      control={control}
      render={({ field }) => (
        <Stack gap="xs">
          <Text fw={400} size="sm">
            Enrollment instructions
          </Text>
          <RichTextEditor
            {...field}
            editor={editor}
            onMouseLeave={handleMouseLeave}
          />
        </Stack>
      )}
    />
  );
};

export { EnrollmentInstructionsEditor };
